import type { FaireProductEntity } from "../../entity_types/product";

export const p_u2wfxhgs92: FaireProductEntity = {
  token: "p_u2wfxhgs92",
  type: "product",
  name: "Jacquard Patchwork Slim-Fit Commuter Jacket",
  brandToken: "b_wrt3xtnbxw",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/890741109e32c3515790d1b8276dece21bfcc2a61eb4389945fd1be0d9f06201.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e0945d38274cf3df94cfd69dc67dca738cfcf608dedc5bed28fc6a8b59798ffc.jpeg",
    "https://cdn.faire.com/fastly/8c66be7367eb37a9524e5641f8a7035517c5f4ae76b05e40da4e0b8924e293f7.jpeg",
    "https://cdn.faire.com/fastly/0d74ac2552530dc01a48a0e2c7755cfcd496ccaa940e74c226a93187a9f31e9f.jpeg",
    "https://cdn.faire.com/fastly/aabe5c5e1d52572791d90fa6ed7feba6613f0c51c035e76d294a1998ad3efd69.jpeg",
    "https://cdn.faire.com/fastly/640f734bdbdd3e78fffbc4eff6254d7b9307326cbaa195192695712981f826c5.jpeg",
    "https://cdn.faire.com/fastly/6164822b523862b1630b651c1811cad8618eb55bd9901055d5b515e0203df8cb.jpeg",
    "https://cdn.faire.com/fastly/7dd96f17488509aca8a7380f6ddc850d45051d174885d11d7ee299ed13c7d870.jpeg",
    "https://cdn.faire.com/fastly/81cad3c4656b299b01077377282ef66abc1440b1841c2e42997f7cf88393543a.jpeg",
    "https://cdn.faire.com/fastly/899eca437487414517140c58362c83765718ca4c6ed597f07b76da49383da7a7.jpeg",
    "https://cdn.faire.com/fastly/00272dcd140f700d3e695867cf14805743c827b9d6ef7a57cd5080caa6255f71.jpeg",
    "https://cdn.faire.com/fastly/aeae95379fc15117de26c219bf26bdccc8283161352d7198425e2f632d12c3d1.jpeg",
    "https://cdn.faire.com/fastly/a84397409522cd192a7e1e5fa2910b2bd2d2d79a489afe4860d0e71acb0549d9.jpeg",
    "https://cdn.faire.com/fastly/4e915828a910b3903f3f98646b2dbab76791573c04d40c19e13f55902b2e73fa.jpeg",
    "https://cdn.faire.com/fastly/6fa41c2156607a5294bc4d23cdf9f92aaa21b7c40f7efe1c5a2b8adfd9d299df.jpeg",
    "https://cdn.faire.com/fastly/22f00a4219a8fb2217d20850f0ed946b45c43f60a5adfc1a662bf5a644cfb6e7.jpeg",
    "https://cdn.faire.com/fastly/ea13cd6b47c436f945ffbae1573f36c85a105182a529f8df1c423bab4c96d37f.jpeg",
    "https://cdn.faire.com/fastly/04d0187e18eb85d7e95b201b632fa86a8fd58415bab67a40ba2e3b37bdbfdaf4.jpeg",
  ],
  priceDollars: 45.5,
  description:
    "UPGRADE YOUR COMMUTE WITH THIS SLEEK JACQUARD PATCHWORK JACKET, FEATURING A TAILORED SLIM FIT AND SOPHISTICATED TEXTURED FABRIC FOR MODERN URBAN STYLE.\n\nIMPORTED, DESIGNED IN USA\n\nINTRICATE JACQUARD PATCHWORK DESIGN\n\nTAILORED SLIM FIT AND FUNCTIONAL LONG SLEEVES\n\nCONT 100% POLYESTER\n\nModel is 5'9\" and is wearing a small. Please see size chart for detail.\n\nShips from China. All Tax and duty covered",
  tags: [],
  msrpDollars: 91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:36.995Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
